import { render, staticRenderFns } from "./DocumentUploader.vue?vue&type=template&id=beec09e0&scoped=true"
import script from "./DocumentUploader.vue?vue&type=script&lang=js"
export * from "./DocumentUploader.vue?vue&type=script&lang=js"
import style0 from "./DocumentUploader.vue?vue&type=style&index=0&id=beec09e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "beec09e0",
  null
  
)

export default component.exports